import { motion } from "framer-motion";
import Image from "next/image";
import type { IProduct } from "../types/products";

interface IProductHeroProps {
  producer?: string;
  product?: IProduct;
}

export const ProductHero = ({ product, producer }: IProductHeroProps) => {
  const options = product?.en
    ? product?.en?.PVCDetails?.options
    : product?.PVCDetails?.options;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2">
      <div className="order-last md:order-first">
        <Image
          alt={product?.title || "Product photo"}
          height={1000}
          priority
          src={
            (product?.PVCDetails?.photo?.sourceUrl
              ? product?.PVCDetails?.photo?.sourceUrl
              : product?.en?.PVCDetails?.photo?.sourceUrl) || ""
          }
          style={{ height: "auto", width: "100%" }}
          width={1000}
        />
      </div>
      <div className="flex flex-col justify-around gap-6 py-6 md:gap-0">
        <div>
          {producer && (
            <Image
              alt={producer}
              height={181}
              src={`/img/partners/${producer}.png`}
              width={151}
            />
          )}
          <h4 className="font-bold text-5xl md:text-7xl">
            {product?.PVCDetails?.h1
              ? product?.PVCDetails?.h1
              : product?.en?.PVCDetails?.h1}
          </h4>
          <h5 className="font-normal text-7xl">
            {product?.PVCDetails?.h2
              ? product?.PVCDetails?.h2
              : product?.en?.PVCDetails?.h2}
          </h5>
          <h6 className="font-thin text-2xl">
            {product?.PVCDetails?.h3
              ? product?.PVCDetails?.h3
              : product?.en?.PVCDetails?.h3}
          </h6>
        </div>
        <div className="flex flex-wrap justify-center">
          {options?.map((option: string) => (
            <motion.div
              className="p-2"
              key={option}
              transition={{ damping: 10, stiffness: 400, type: "spring" }}
              whileHover={{ scale: 1.1 }}
            >
              <Image
                alt={option}
                height={95}
                src={`/img/pvc/${option}.png`}
                width={95}
              />
            </motion.div>
          ))}
        </div>
        {(product?.PVCDetails?.pdf?.mediaItemUrl ||
          product?.en?.PVCDetails?.pdf?.mediaItemUrl) && (
          <div className="mx-auto">
            <a
              className="rounded-md bg-gradient-to-r from-red to-orange px-5 py-2 font-bold text-white text-xl hover:bg-gradient-to-t"
              href={
                product?.PVCDetails?.pdf?.mediaItemUrl
                  ? product?.PVCDetails?.pdf?.mediaItemUrl
                  : product?.en?.PVCDetails?.pdf?.mediaItemUrl
              }
              rel="noreferrer noopener"
              target="_blank"
            >
              POBIERZ ULOTKĘ
            </a>
          </div>
        )}
      </div>
    </div>
  );
};
